// ABOUTME: Whether the object schema form shows and saves read filters: a PIM_SUPERADMIN on a company with a tenant package.
// ABOUTME: The role is checked first, so nobody else even asks the server.

import { useAuth } from '@src/hooks';

import { useReadFiltersAvailableQuery } from '../graphql/ReadFilters.generated';

const SUPERADMIN_ROLE = 'PIM_SUPERADMIN';

export function useReadFiltersAvailable(): boolean {
    const { hasUserRole } = useAuth();
    const isSuperAdmin = hasUserRole(SUPERADMIN_ROLE);
    const { data } = useReadFiltersAvailableQuery({ skip: !isSuperAdmin });
    return isSuperAdmin && !!data?.readFiltersAvailable;
}
